import { useTranslation } from "react-i18next";

import { TnufaLoginStepFormFieldsEnum, yupLanding } from "@ryde/utils-landings";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useYupLoginLandingTnufaValidationSchema = () => {
  const { t } = useTranslation();
  const yupLoginLandingTnufaValidationSchema = {
    [TnufaLoginStepFormFieldsEnum.FirstName]: yupLanding.string().required(),
    [TnufaLoginStepFormFieldsEnum.lastName]: yupLanding.string().required(),
    [TnufaLoginStepFormFieldsEnum.Unit]: yupLanding.number().required(),
    [TnufaLoginStepFormFieldsEnum.Phone]: yupLanding.string().required(),
    [TnufaLoginStepFormFieldsEnum.SourceStation2Id]: yupLanding
      .number()
      .required(),
    [TnufaLoginStepFormFieldsEnum.AcceptTerms]: yupLanding
      .boolean()
      .oneOf([true], t("landing.validation.acceptTermsRequired")),
    [TnufaLoginStepFormFieldsEnum.AcceptPrivacyPolicy]: yupLanding
      .boolean()
      .oneOf([true], t("landing.validation.acceptPrivacyPolicyRequired")),
  };

  return { yupLoginLandingTnufaValidationSchema };
};
